module.exports = __webpack_public_path__ + "img/site_type_img_19.31806073.png";